module.exports = __webpack_public_path__ + "img/logo2.042a982b.png";